function modifyWeatherText() {
  setInterval(() => {
    const str = $('#weatherBugDescription').text();
    const weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    const findSpace = str.lastIndexOf(' ');
    const stringLength = str.length;
    const res = str.substring(findSpace, stringLength);
    const start = str.substring(0, findSpace);
    if (!weatherBugSet && str !== '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      $('#weatherBugDescription').html(
        `<span class="weatherDescriptive">${start}</span>${res}`
      );
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
}

function modifyCopyright() {
  const address = document.querySelector('p');
  address.innerHTML = address.innerHTML.replace('Avenue', 'Avenue<br>');
}

function applyMaskImageContent() {
  $('.dynamicPageContainer .sectionHeading').each(function () {
    const text = $(this).text();
    if (text === '{picture-border}') {
      $(this).parent('.entityContainerRow').addClass('customImage');
      $(this).css('display', 'none');
    }
  });
}

function mapHeight() {
  const imgHeight = $('.map-section img').height();
  $('.map-section').css('max-height', imgHeight);
  $('.map-section a').css('max-height', imgHeight);
  $('.map-section picture').css('max-height', imgHeight);
}

function modifyLineupModule() {
  const modules = $('.featureLineupModule .featureLineupContainer');
  modules.each((index, module) => {
    const subContainer = $(module).find('.subContainer:first-child');
    const moreButton = $(module).find('.featureLineup-more');
    const moreButtonLink = $(moreButton).find('a').attr('href');
    // wrap the subContainer in a link
    const link = $('<a href="#"></a>');
    link.attr('href', moreButtonLink);
    link.insertBefore(subContainer);
    link.append(subContainer);
    moreButton.remove();
    $(module).find('.featureLineup-headline').remove();
  });
}

function logoHeight(scroll) {
  let headerLogoHeight = $('.header-logo').height();
  const headerLogoMask = $('.logo-mask');

  if (!scroll) {
    setTimeout(() => {
      headerLogoMask.css('height', headerLogoHeight * 0.72);
    }, 1500);
    setTimeout(() => {
      headerLogoMask.css('overflow', 'hidden');
    }, 1700);
  } else {
    headerLogoMask.css('overflow', 'visible');
    setTimeout(() => {
      headerLogoHeight = $('.header-logo').height();
      headerLogoMask.css('height', headerLogoHeight * 0.72);
    }, 200);
    setTimeout(() => {
      headerLogoMask.css('overflow', 'hidden');
    }, 600);
  }
}

let executedForCoundown = {
  small: false,
  medium: false,
  large: false,
};

function countdownResize() {
  function countdownStyle() {
    const countdown = $('#siteInfoBannerWidget');
    const countdownContainer = $('#countdownMobile');

    countdown.css('opacity', '0');
    if (window.innerWidth <= 804) {
      countdownContainer.append(countdown);
    } else {
      $('.middle-nav').append(countdown);
    }
    setTimeout(() => {
      countdown.css('opacity', '1');
    }, 500);
  }

  const windowWidth = window.innerWidth;

  if (windowWidth < 804 && executedForCoundown.small === false) {
    countdownStyle();
    executedForCoundown = { small: true, medium: false, large: false };
  } else if (
    windowWidth >= 805 &&
    windowWidth <= 1300 &&
    executedForCoundown.medium === false
  ) {
    countdownStyle();
    executedForCoundown = { small: false, medium: true, large: false };
  } else if (windowWidth > 1300 && executedForCoundown.large === false) {
    countdownStyle();
    executedForCoundown = { small: false, medium: false, large: true };
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyWeatherText();
  applyMaskImageContent();

  if ($(window).width() < 768) {
    modifyCopyright();
  }
  if (window.location.pathname === '/businesses') {
    $('h1').remove();
  }
});

$(window).load(() => {
  // ---
  if ($('#siteInfoBannerWidget').length) {
    countdownResize();
  }
  modifyLineupModule();
  logoHeight(false);
  $(window).resize(() => {
    if ($('#siteInfoBannerWidget').length) {
      countdownResize();
    }
    logoHeight(false);
  });

  let prevScrollPos = $(window).scrollTop();
  $(window).scroll(() => {
    const currentScrollPos = $(window).scrollTop();
    if (currentScrollPos > prevScrollPos || currentScrollPos === 0) {
      logoHeight(true);
    }
    prevScrollPos = currentScrollPos;
  });

  if (window.location.pathname === '/') {
    // is homepage
    mapHeight();
  }
});
